module.exports = __webpack_public_path__ + "img/3.a25563e3.png";